import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex);

export const store = new Vuex.Store({
  state: {
    listAwardsTypes: ['certificate', 'diploma', 'attestation'],
    listGalleriesTypes: ['image', 'video', 'document', 'audio'],
    listNewsTypes: null,
    listProjectsTypes: null,
    tables: null,
    crudOperations: ['create', 'read', 'update', 'delete'],
    selectedOperation: 'create',
    selectedComponent: 'awards',
    selectedCrudComponent: 'app-create-awards',
    previousOperation: '',
    currentElement: null,
    // baseURL: 'http://adminpanel.ridiluamba.com/restapi_ridi_website/',
    baseURL: 'http://localhost/myprojects/restapi_ridi_website/',
    admin: null
  },
  getters: {
    getOperation: state => {
      return state.selectedOperation;
    },
    getComponent: state => {
      return state.selectedComponent;
    },
    getTables: state => {
      return state.tables;
    },
    getCrudOperations: state => {
      return state.crudOperations;
    },
    getCrudComponent: state => {
      return state.selectedCrudComponent;
    },
    getAwardsTypes: state => {
      return state.listAwardsTypes;
    },
    getGalleriesTypes: state => {
      return state.listGalleriesTypes;
    },
    getNewsTypes: state => {
      return state.listNewsTypes;
    },
    getProjectsTypes: state => {
      return state.listProjectsTypes;
    },
    getCurrentElement: state => {
      return state.currentElement;
    },
    getPreviousOperation: state => {
      return state.previousOperation;
    },
    getBaseURL: state => {
      return state.baseURL;
    },
    getAdmin: state => {
      return state.admin;
    }
  },
  mutations: {
    setOperation: (state, payload) => {
      state.selectedOperation = payload;
      sessionStorage.setItem('selectedOperation', payload);
    },
    setComponent: (state, payload) => {
      state.selectedComponent = payload;
      sessionStorage.setItem('selectedComponent', payload);
    },
    setCrudComponent: (state, payload) => {
      state.selectedCrudComponent = payload;
    },
    setCurrentElement: (state, payload) => {
      state.currentElement = payload;
    },
    setPreviousOperation: (state, payload) => {
      state.previousOperation = payload;
    },
    storeTables: (state, payload) => {
      state.tables = payload
    },
    storeListNewsTypes: (state, payload) => {
      state.listNewsTypes = payload
    },
    storeListProjectsTypes: (state, payload) => {
      state.listProjectsTypes = payload
    },
    storeAdmin: (state, payload) => {
      state.admin = payload
    },
    clearAdmin: (state) => {
      state.admin = null
    }
  },
  actions: {
    setOperation: ({ commit }, payload) => {
      commit('setOperation', payload)
    },
    setComponent: ({ commit }, payload) => {
      commit('setComponent', payload)
    },
    setCrudComponent: ({ commit }, payload) => {
      commit('setCrudComponent', payload)
    },
    setCurrentElement: ({ commit }, payload) => {
      commit('setCurrentElement', payload)
    },
    setPreviousOperation: ({ commit }, payload) => {
      commit('setPreviousOperation', payload)
    },
    uploadFile: ({}, formImage) => {
      return axios.post( '../upload_file.php', formImage,{ headers: {'Content-Type': 'multipart/form-data'} })
        .then(response => {
          console.log(response);
          return [true, response.data.message, response.data.src]
        })
        .catch(error => {
            let message = '';
            if(error.response){
              for (const errMsg in error.response.data.message)
                message += error.response.data.message[errMsg] + '<br>';
              console.log(error.response);
            }
            console.log(error);
            return [false, message, error.response.data.src]
          });
    },
    removeFile: ({}, src) => {
      return axios.delete('../remove_file.php', { data: {'src' : src} })
        .then(response => {
          console.log(response);
          return [true, 'Your file has been deleted successfully !', '']
        })
        .catch(error => {
          console.log(error);
          if(error.response) console.log(error.response)
        });

    },
    sendMail: ({}, data) => {
      return axios.post('../'+ data.url +'.php', data.data)
        .then(response => {
          console.log(response);
          return response.data.message
        })
        .catch(error => {
          console.log(error);
          if(error.response) console.log(error.response);
          return error
        });
    },
    readNumRowsTables: ({commit}) => {
      axios.get('../count_rows.php')
        .then(response => {
          commit('storeTables', response.data);
          console.log(response.data);
        })
        .catch(error => console.log(error));
    },
    createData: ({dispatch, commit, state}, formData) => {
      return axios.post(state.selectedComponent + '/create.php', formData)
        .then(response => {
          console.log(response);
          dispatch('readNumRowsTables')
            .then(data => commit('storeTables', data))
            .catch();
          return response.data.message;
        })
        .catch(error => console.log(error.response));
    },
    readData: ({state}) => {
      return axios.get(state.selectedComponent + '/read.php')
        .then(response => {
          console.log(response.data.data);
          return response.data.data;
        })
        .catch(error => console.log(error.response));
    },
    readOneData: ({state}) => {
      return axios.get(state.selectedComponent + '/read_one.php', { params: {id: state.currentElement ? state.currentElement.id : ''} })
        .then(response => {
          console.log(response.data);
          return response.data;
        })
        .catch(error => console.log(error));
    },
    updateData: ({state}, formData) => {
      return axios.put(state.selectedComponent + '/update.php', formData)
        .then(response => {
          console.log(response);
          return response.data.message;
        })
        .catch(error => console.log(error.response));
    },
    deleteData: ({dispatch, commit, state}, formData) => {
      return axios.delete(state.selectedComponent + '/delete.php', { data : formData })
        .then(response => {
          console.log(response);
          dispatch('readNumRowsTables')
            .then(data => commit('storeTables', data))
            .catch();
          return response.data.message
        })
        .catch(error => {
          console.log(error);
        });
    },
    axiosGet: ({commit, state}, obj) => {
      axios.get(obj.component + '/read.php')
        .then(response => {
          commit('store'+obj.state.charAt(0).toUpperCase() + obj.state.slice(1), response.data.data);
          console.log(response.data.data);
        })
        .catch(error => console.log(error.response));
    },
    login: ({commit, state}, formData) => {
      axios.post('admin/read.php', formData, {withCredentials: true})
        .then(response => {
          commit('storeAdmin', response.data);
          localStorage.setItem("admin", "logged_in");
          console.log(response.data);
        })
        .catch(error => console.log(error.response));
    },
    autoLogin: ({dispatch}) => {
      // if(localStorage.getItem("admin") === "logged_in"){
        axios.get('admin/reconnect.php', {withCredentials: true})
          .then(response => {
            console.log(response)
          })
          .catch(error => console.log(error.response))
      // }
        // dispatch('login').then().catch()
    },
    logout: ({commit, state}) => {
      axios.put('admin/update.php', state.admin)
        // .then(response => {
        //   commit('clearAdmin');
        //   console.log(response.data);
        // })
        // .catch(error => console.log(error.response));
    }
  }
});



// WEBPACK FOOTER //
// ./src/store/index.js